module.exports = __webpack_public_path__ + "img/pcIcon.4e2b7b5f.png";